import { render, staticRenderFns } from "./DashboardVentas.vue?vue&type=template&id=ebc89bc4&scoped=true&"
import script from "./DashboardVentas.vue?vue&type=script&lang=js&"
export * from "./DashboardVentas.vue?vue&type=script&lang=js&"
import style0 from "./DashboardVentas.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DashboardVentas.vue?vue&type=style&index=1&id=ebc89bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc89bc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardSubtitle,VCardText,VCardTitle,VCol,VContainer,VDialog,VIcon,VImg,VProgressLinear,VRow,VSpacer})
